export default "__VITE_ASSET__Bq4$Eymq__"